import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-dialog-input',
    templateUrl: './dialog-input.component.html',
    styleUrls: ['./dialog-input.component.css']
})
export class DialogInputComponent implements OnInit {

    @Input()
    title: string;

    constructor() {
    }

    ngOnInit() {
    }
}
